// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
// MED-41 — sends a picked file straight to storage and emits the progress
// events direct_upload_controller.js draws.
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
// Exposes window.TurboNativeBridge for the Hotwire Native shells
import "./src/turbo_native/bridge"

import "trix"
import "@rails/actiontext"
// Trims the Trix toolbar down to what a rich slot may contain
import "./src/rich_text/trix_slots"
